/* Marelle - Happenings: month navigation, detail dialog, .ics download.
   Companion to sections/marelle-happenings.liquid.

   Data flow: the section pre-renders every month and every event's detail
   card server-side. This script only shows/hides them, wires close/Escape/
   backdrop-click, and generates a real RFC 5545 .ics on demand.
*/

(function () {
  'use strict';

  var EASING = 'cubic-bezier(.22,.61,.36,1)';

  /* Pre-computed VTIMEZONE blocks. Standard US rules: DST second Sunday in
     March at 02:00, standard first Sunday in November at 02:00. This is
     what Google Calendar and Apple Calendar emit. When adding a timezone
     option to the section schema, add the matching constant here. */
  var VTIMEZONES = {
    'America/Chicago': [
      'BEGIN:VTIMEZONE',
      'TZID:America/Chicago',
      'BEGIN:DAYLIGHT',
      'TZOFFSETFROM:-0600',
      'TZOFFSETTO:-0500',
      'TZNAME:CDT',
      'DTSTART:19700308T020000',
      'RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU',
      'END:DAYLIGHT',
      'BEGIN:STANDARD',
      'TZOFFSETFROM:-0500',
      'TZOFFSETTO:-0600',
      'TZNAME:CST',
      'DTSTART:19701101T020000',
      'RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU',
      'END:STANDARD',
      'END:VTIMEZONE'
    ].join('\r\n'),

    'America/New_York': [
      'BEGIN:VTIMEZONE',
      'TZID:America/New_York',
      'BEGIN:DAYLIGHT',
      'TZOFFSETFROM:-0500',
      'TZOFFSETTO:-0400',
      'TZNAME:EDT',
      'DTSTART:19700308T020000',
      'RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU',
      'END:DAYLIGHT',
      'BEGIN:STANDARD',
      'TZOFFSETFROM:-0400',
      'TZOFFSETTO:-0500',
      'TZNAME:EST',
      'DTSTART:19701101T020000',
      'RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU',
      'END:STANDARD',
      'END:VTIMEZONE'
    ].join('\r\n')
  };

  function pad2(n) {
    return String(n).length < 2 ? '0' + n : String(n);
  }

  /* RFC 5545 text escape: backslash first, then semicolon, comma, newline.
     The prototype only escaped commas -- this is the plan's fixing that. */
  function icsEscape(text) {
    if (text == null) return '';
    return String(text)
      .replace(/\\/g, '\\\\')
      .replace(/;/g, '\\;')
      .replace(/,/g, '\\,')
      .replace(/\r\n|\r|\n/g, '\\n');
  }

  function icsUtcStamp(date) {
    return date.getUTCFullYear()
      + pad2(date.getUTCMonth() + 1)
      + pad2(date.getUTCDate())
      + 'T'
      + pad2(date.getUTCHours())
      + pad2(date.getUTCMinutes())
      + pad2(date.getUTCSeconds())
      + 'Z';
  }

  function normalizeTime(hhmm) {
    if (typeof hhmm !== 'string') return null;
    var m = /^\s*(\d{1,2}):(\d{2})\s*$/.exec(hhmm);
    if (!m) return null;
    var h = parseInt(m[1], 10);
    var mm = parseInt(m[2], 10);
    if (isNaN(h) || h < 0 || h > 23) return null;
    if (isNaN(mm) || mm < 0 || mm > 59) return null;
    return pad2(h) + pad2(mm);
  }

  function icsLocalStamp(iso, hhmm) {
    var d = String(iso || '').replace(/-/g, '');
    var t = normalizeTime(hhmm);
    if (!d || d.length !== 8 || !t) return null;
    return d + 'T' + t + '00';
  }

  function slugify(text) {
    return String(text || 'event').toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '')
      .slice(0, 60) || 'event';
  }

  function buildICS(opts) {
    var tz = opts.timezone && VTIMEZONES[opts.timezone] ? opts.timezone : 'America/Chicago';
    var vtz = VTIMEZONES[tz];
    var dtstart = icsLocalStamp(opts.iso, opts.start);
    var dtend = icsLocalStamp(opts.iso, opts.end);
    if (!dtstart || !dtend) return null;

    var uid = (opts.blockId || 'event-' + Date.now()) + '@' + (opts.shopDomain || 'marelle');
    var dtstamp = icsUtcStamp(new Date());
    var location = [opts.venue, opts.address].filter(function (s) { return s && String(s).length; }).join(', ');

    return [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//Marelle//Happenings//EN',
      'CALSCALE:GREGORIAN',
      vtz,
      'BEGIN:VEVENT',
      'UID:' + uid,
      'DTSTAMP:' + dtstamp,
      'DTSTART;TZID=' + tz + ':' + dtstart,
      'DTEND;TZID=' + tz + ':' + dtend,
      'SUMMARY:' + icsEscape(opts.title),
      'LOCATION:' + icsEscape(location),
      'DESCRIPTION:' + icsEscape(opts.description),
      'END:VEVENT',
      'END:VCALENDAR'
    ].join('\r\n');
  }

  function downloadICS(opts) {
    var ics = buildICS(opts);
    if (!ics) return;
    var filename = slugify(opts.title) + '.ics';
    try {
      var blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
    } catch (err) {
      var dataUrl = 'data:text/calendar;charset=utf-8,' + encodeURIComponent(ics);
      window.location.href = dataUrl;
    }
  }

  var FOCUSABLE_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  var scrollLockCount = 0;
  function lockScroll() {
    scrollLockCount++;
    if (scrollLockCount === 1) {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }
  }
  function unlockScroll() {
    scrollLockCount = Math.max(0, scrollLockCount - 1);
    if (scrollLockCount === 0) {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }
  }

  function MarelleHappenings() {
    return Reflect.construct(HTMLElement, [], MarelleHappenings);
  }
  MarelleHappenings.prototype = Object.create(HTMLElement.prototype);
  MarelleHappenings.prototype.constructor = MarelleHappenings;
  Object.setPrototypeOf(MarelleHappenings, HTMLElement);

  MarelleHappenings.prototype.connectedCallback = function () {
    if (this._booted) return;
    this._booted = true;

    this.timezone = this.dataset.timezone || 'America/Chicago';
    this.shopDomain = this.dataset.shopDomain || 'marelle';
    this.rangeSpan = parseInt(this.dataset.rangeSpan || '0', 10);
    this.currentOffset = parseInt(this.dataset.initialOffset || '0', 10);

    this.months = Array.prototype.slice.call(this.querySelectorAll('.marelle-happenings__month'));
    this.scrim = this.querySelector('[data-scrim]');
    this.cards = Array.prototype.slice.call(this.querySelectorAll('.marelle-happenings__card'));
    this.activeCard = null;
    this.previouslyFocused = null;
    this._keydownHandler = this._onKeydown.bind(this);

    this._wireMonthNav();
    this._wireOpenTriggers();
    this._wireDialog();
    this._wireStripAffordance();
    this._wireSignupCapture();
    this._restoreFromSubmit();
  };

  MarelleHappenings.prototype._wireMonthNav = function () {
    var self = this;
    this.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-nav]');
      if (!btn || !self.contains(btn)) return;
      if (btn.hasAttribute('disabled')) return;
      var dir = btn.dataset.nav === 'next' ? 1 : -1;
      e.preventDefault();
      self._gotoOffset(self.currentOffset + dir, dir);
    });
  };

  MarelleHappenings.prototype._gotoOffset = function (offset, direction) {
    if (offset < 0 || offset > this.rangeSpan) return;

    var newMonth = null;
    this.months.forEach(function (m) {
      var mo = parseInt(m.dataset.monthOffset, 10);
      if (mo === offset) {
        m.removeAttribute('hidden');
        newMonth = m;
      } else {
        m.setAttribute('hidden', '');
      }
    });
    this.currentOffset = offset;

    /* Strip metrics (scrollWidth, clientWidth) are only accurate once the
       month is visible and the browser has laid it out. Defer to next
       frame so the fade / arrow visibility reflects the new strip. */
    if (newMonth && typeof newMonth._stripUpdate === 'function') {
      requestAnimationFrame(newMonth._stripUpdate);
    }

    if (direction && newMonth) {
      var wanted = direction > 0 ? 'next' : 'prev';
      var focusTarget = newMonth.querySelector('[data-nav="' + wanted + '"]:not([disabled])');
      if (!focusTarget) {
        var opposite = direction > 0 ? 'prev' : 'next';
        focusTarget = newMonth.querySelector('[data-nav="' + opposite + '"]:not([disabled])');
      }
      if (focusTarget) {
        focusTarget.focus();
      }
    }
  };

  MarelleHappenings.prototype._wireOpenTriggers = function () {
    var self = this;
    this.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-nav]')) return;
      if (e.target.closest('[data-close]')) return;
      if (e.target.closest('[data-add-ics]')) return;
      if (e.target.closest('.marelle-happenings__card')) return;

      var trigger = e.target.closest('[data-event-id]');
      if (!trigger) return;
      var id = trigger.dataset.eventId;
      if (!id) return;
      e.preventDefault();
      self._openCard(id);
    });
  };

  MarelleHappenings.prototype._wireDialog = function () {
    var self = this;
    if (this.scrim) {
      this.scrim.addEventListener('click', function () {
        self._closeCard();
      });
    }
    this.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-close]')) {
        self._closeCard();
        return;
      }
      var addBtn = e.target.closest('[data-add-ics]');
      if (addBtn) {
        var card = addBtn.closest('.marelle-happenings__card');
        if (card) self._addToCalendar(card);
      }
    });
  };

  /* Strip scroll affordance: per-month, watch scroll state and toggle fade
     opacity (via data-scroll-start/-end on the wrapper) and nav-button
     [hidden] attribute. Runs at both breakpoints; visible only on mobile
     because CSS keeps fades and nav display: none on desktop. */
  MarelleHappenings.prototype._wireStripAffordance = function () {
    var self = this;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.months.forEach(function (monthEl) {
      var wrap = monthEl.querySelector('.marelle-happenings__strip-wrap');
      var strip = monthEl.querySelector('.marelle-happenings__strip');
      var prevBtn = monthEl.querySelector('.marelle-happenings__strip-nav--prev');
      var nextBtn = monthEl.querySelector('.marelle-happenings__strip-nav--next');
      if (!wrap || !strip) return;

      var update = function () {
        /* If the month is [hidden] its strip has 0 clientWidth; skip. */
        if (strip.clientWidth === 0) return;
        var scrollable = strip.scrollWidth > strip.clientWidth + 1;
        var atStart = strip.scrollLeft <= 1;
        var atEnd = strip.scrollLeft >= (strip.scrollWidth - strip.clientWidth - 1);
        wrap.setAttribute('data-scroll-start', atStart ? 'true' : 'false');
        wrap.setAttribute('data-scroll-end', atEnd ? 'true' : 'false');
        if (prevBtn) {
          if (!scrollable || atStart) prevBtn.setAttribute('hidden', '');
          else prevBtn.removeAttribute('hidden');
        }
        if (nextBtn) {
          if (!scrollable || atEnd) nextBtn.setAttribute('hidden', '');
          else nextBtn.removeAttribute('hidden');
        }
      };

      var weekDelta = function () {
        var cell = strip.querySelector('.marelle-happenings__day');
        var w = cell ? cell.offsetWidth : 27;
        return w * 7;
      };

      var scrollByDelta = function (delta) {
        try {
          strip.scrollBy({ left: delta, behavior: reducedMotion ? 'auto' : 'smooth' });
        } catch (_) {
          /* Older Safari doesn't accept the options object -- fall back. */
          strip.scrollLeft += delta;
        }
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          e.preventDefault();
          scrollByDelta(-weekDelta());
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          e.preventDefault();
          scrollByDelta(weekDelta());
        });
      }

      strip.addEventListener('scroll', update, { passive: true });

      /* Expose so _gotoOffset can refresh on month change. */
      monthEl._stripUpdate = update;

      /* Initial paint. Deferred so layout has settled. */
      requestAnimationFrame(update);
    });

    /* Resize -- re-evaluate every month's strip (breakpoint may have flipped). */
    window.addEventListener('resize', function () {
      self.months.forEach(function (m) {
        if (typeof m._stripUpdate === 'function') m._stripUpdate();
      });
    });
  };

  MarelleHappenings.prototype._openCard = function (id) {
    var card = this.cards.find(function (c) { return c.dataset.cardId === id; });
    if (!card) return;
    if (this.activeCard === card) return;

    this.previouslyFocused = document.activeElement;

    if (this.scrim) {
      this.scrim.removeAttribute('hidden');
    }
    card.removeAttribute('hidden');
    /* Force reflow so a re-open re-triggers the entrance animation. */
    void card.offsetHeight;

    this.activeCard = card;
    lockScroll();
    window.addEventListener('keydown', this._keydownHandler);

    var focusTarget = card.querySelector('[data-close]') || card;
    var self = this;
    requestAnimationFrame(function () {
      try { focusTarget.focus({ preventScroll: true }); }
      catch (_) { try { focusTarget.focus(); } catch (__) {} }
    });
  };

  MarelleHappenings.prototype._closeCard = function () {
    if (!this.activeCard) return;
    this.activeCard.setAttribute('hidden', '');
    if (this.scrim) this.scrim.setAttribute('hidden', '');
    unlockScroll();
    window.removeEventListener('keydown', this._keydownHandler);
    var returnTo = this.previouslyFocused;
    this.activeCard = null;
    this.previouslyFocused = null;
    if (returnTo && typeof returnTo.focus === 'function') {
      try { returnTo.focus({ preventScroll: true }); }
      catch (_) { try { returnTo.focus(); } catch (__) {} }
    }
  };

  MarelleHappenings.prototype._onKeydown = function (e) {
    if (!this.activeCard) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      this._closeCard();
      return;
    }
    if (e.key === 'Tab') {
      this._trapTab(e);
    }
  };

  MarelleHappenings.prototype._trapTab = function (e) {
    var card = this.activeCard;
    if (!card) return;
    var focusables = card.querySelectorAll(FOCUSABLE_SELECTOR);
    if (!focusables.length) {
      e.preventDefault();
      card.focus();
      return;
    }
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    var active = document.activeElement;
    if (!card.contains(active)) {
      e.preventDefault();
      first.focus();
      return;
    }
    if (e.shiftKey && active === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus();
    }
  };

  MarelleHappenings.prototype._addToCalendar = function (card) {
    downloadICS({
      blockId: card.dataset.cardId,
      shopDomain: this.shopDomain,
      timezone: this.timezone,
      iso: card.dataset.eventIso,
      start: card.dataset.eventStart,
      end: card.dataset.eventEnd,
      title: card.dataset.eventTitle,
      venue: card.dataset.eventVenue,
      address: card.dataset.eventAddress,
      description: card.dataset.eventDescription
    });
  };

  /* Signup form submits: record the current month offset in sessionStorage
     BEFORE the browser navigates. On the reload we restore that offset so
     the empty state with the inline success / error message is what the
     visitor sees, not the server-default month. */
  MarelleHappenings.prototype._wireSignupCapture = function () {
    this.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('.marelle-happenings__signup-form');
      if (!form) return;
      var monthEl = form.closest('.marelle-happenings__month');
      if (!monthEl) return;
      var mo = monthEl.dataset.monthOffset;
      if (mo == null) return;
      try {
        sessionStorage.setItem('marelle-happenings:restore-offset', String(mo));
      } catch (_) {}
    });
  };

  /* Post-submit restore. Runs once on connect. Reads the offset set by
     _wireSignupCapture on the previous page load, switches to that month,
     and gently scrolls the empty state into view. Clears the sessionStorage
     key at the start so the inline sync-hide fallback timer knows this
     script ran. If restore fails (invalid offset), reveal the section-top
     message that was pre-hidden by the inline script. */
  MarelleHappenings.prototype._restoreFromSubmit = function () {
    var raw = null;
    try {
      raw = sessionStorage.getItem('marelle-happenings:restore-offset');
    } catch (_) {}
    if (raw == null) return;

    try { sessionStorage.removeItem('marelle-happenings:restore-offset'); } catch (_) {}

    var idx = parseInt(raw, 10);
    var self = this;

    if (isNaN(idx) || idx < 0 || idx > this.rangeSpan) {
      /* Invalid offset -- reveal the section-top msg if it was pre-hidden. */
      var msg = this.querySelector('.marelle-happenings__section-top-msg');
      if (msg) msg.removeAttribute('hidden');
      return;
    }

    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    requestAnimationFrame(function () {
      self._gotoOffset(idx);
      var target = self.months.find(function (m) {
        return parseInt(m.dataset.monthOffset, 10) === idx;
      });
      var empty = target && target.querySelector('.marelle-happenings__empty');
      if (empty && typeof empty.scrollIntoView === 'function') {
        try {
          empty.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
        } catch (_) {
          empty.scrollIntoView();
        }
      }
    });
  };

  if (!customElements.get('marelle-happenings')) {
    customElements.define('marelle-happenings', MarelleHappenings);
  }
})();
